import React, { useState, useEffect } from "react";
import BoxContainer from "../../../ui/BoxContainer";
import ButtonSquare from "../../../ui/ButtonSquare";
import { Box, Button, Divider, Modal, Typography, InputAdornment, Autocomplete, TextField, CircularProgress } from "@mui/material";
import { colors } from "../../../../theme/Colors";
import { modalStyle } from "../../../../theme/ModalStyle";
import { Formik, Form, Field, ErrorMessage } from "formik";
import MyTextField from "../../../ui/MyTextField";
import MyDatePicker from "../../../ui/MyDatePicker";
import MyDP from "../../../ui/MyDP";
import checkLinkicon from "../../../../imgs/imgV2/checkLinkIcon.svg";
import { useRef } from "react";
import * as Yup from "yup";
import { Urls } from "../../../../api/Urls";
import RechercheIcon from "../../../../imgs/imgV2/RechercheIcon.svg";
import ControlPointRoundedIcon from "@mui/icons-material/ControlPointRounded";

import Api from "../../../../api/Api";
import { useAuthContext } from "../../../../hooks/useAuthContext";
import { ToastContainer, toast } from "react-toastify";
import moment from "moment";
function Scolarite({ updateBord, setUpdateBoard }) {
  const [open, setOpen] = useState(false);
  const formikRef = useRef();
  const { user } = useAuthContext();
  const [openDelete, setOpenDelete] = useState(false);
  const [change, setChange] = useState(false);
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const access_token = user?.access_token;
  const [listeScolar, setListesScolar] = useState([]);
  const [file, setFile] = useState();
  const [scolar, setScolar] = useState([]);
  const [idScolar, setIDScolar] = useState();
  //function to handle when click on the modify icon
  const handleModifyClick = (cert) => {
    //console.log(cert);
    setInitialValues({
      titreObj: cert?.school_document_type,
      titre: cert?.school_document_type?.id,
      date: cert?.obtained_date,
      file: "",
      link_file: cert.url_file,
    });
    setFile("Piéce jointe");
    setOpen(true);
  };
  //function to handle when click on the add icon
  const handleAddClick = () => {
    setInitialValues({
      titre: "",
      date: "",
      file: "",
      link_file: "",
    });
    setFile("");
    setOpen(true);
  };
  const FILE_SIZE = 5000 * 1024;

  //validation schema fot the form
  const validationSchema = Yup.object().shape({
    titre: Yup.string().required("Ce champ est obligatoire"),
    date: Yup.date().required("Ce champ est obligatoire"),
    file: Yup.mixed()
      .required("Veuillez selectionner un fichier")
      .test("fileSize", "Fichier volumineux", (value) => value && value.size <= FILE_SIZE),
  });
  const validationSchemaUpdate = Yup.object().shape({
    titre: Yup.string().required("Ce champ est obligatoire"),
    date: Yup.date().required("Ce champ est obligatoire"),
  });
  const [initialValues, setInitialValues] = useState({
    titre: "",
    titreObj: "",
    date: "",
    file: "",
    link_file: "",
  });
  //get user document
  useEffect(() => {
    Api.get(Urls.GET_SCOLARITE, {
      headers: { "content-type": "application/json", authorization: `Bearer ${access_token}` },
      params: {
        perPage: 4,
      },
    })
      .then((res) => {
        //console.log(res);
        setListesScolar(res?.data?.school_documents);
        setData(res?.data);
        setLoading(false);
      })
      .catch((err) => {
        //console.log(err);
      });
  }, [change]);
  //rechercher des certificat pour le autocomplete
  const SearchScolar = (value) => {
    Api.get(Urls.SEARCH_SCHOOLING, {
      headers: { "content-type": "application/json", authorization: `Bearer ${access_token}` },
      params: {
        search: value,
      },
    })
      .then((res) => {
        //console.log(res);
        setScolar(res?.data?.school_document_types);
      })
      .catch((err) => {
        //console.log(err);
      });
  };
  const [progressScolar, setProgressScolar] = useState(0);
  var configsScolar = {
    headers: {
      "Content-type": "multipart/form-data",
      authorization: `Bearer ${access_token}`,
    },
    onUploadProgress: function (progressEvent) {
      var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
      setProgressScolar(percentCompleted);
    },
  };
  const createScolar = (values) => {
    //console.log(values.titre);
    Api.post(
      Urls.POST_SCOLARITE,
      {
        user_id: user?.user?.id,
        school_document_type_id: values.titre,
        obtained_date: values.date,
        file: values.file,
      },
      configsScolar
    )
      .then((res) => {
        //console.log(res);
        setProgressScolar(0);
        toast.success(res?.data?.message);
        setChange(!change);
        setOpen(false);
        setUpdateBoard(!updateBord);
      })
      .catch((err) => {
        //console.log(err);
        setProgressScolar(0);
        toast.error(err.response.data.message);
      });
  };
  const ModifyScolar = (values, id) => {
    //console.log(values.titre);
    Api.post(
      Urls?.UPDATE_SCOLARITER + id,
      {
        school_document_type_id: values.titre,
        obtained_date: values.date,
        ...(values.file !== "" && { file: values.file }),
      },
      configsScolar
    )
      .then((res) => {
        //console.log(res);
        setProgressScolar(0);
        toast.success(res?.data?.message);
        setIDScolar();
        setChange(!change);
        setOpen(false);
      })
      .catch((err) => {
        //console.log(err);
        setProgressScolar(0);
        setIDScolar();
        toast.error(err.response.data.message);
      });
  };
  //delete certification
  const deleteScolar = () => {
    Api.delete(Urls.DELETE_USER_DOCUMENTS + idScolar, {
      headers: { "content-type": "application/json", authorization: `Bearer ${access_token}` },
    })
      .then((res) => {
        toast.success(res?.data?.message);
        setChange(!change);
        setIDScolar();
        setOpenDelete(false);
        setUpdateBoard(!updateBord);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
      });
  };
  const handlePagination = () => {
    Api.get(`${data.links.next}`, {
      headers: { "content-type": "application/json", authorization: `Bearer ${access_token}` },
      params: {
        perPage: 4,
      },
    }).then((res, err) => {
      if (res?.request?.status === 200) {
        setListesScolar(listeScolar.concat(res?.data?.school_documents));
        setData(res.data);
      }
      if (err) {
        toast.error(err?.response?.data?.message);
      }
    });
  };
  return (
    <Box position="relative">
      <ToastContainer />
      {loading === false ? (
        <BoxContainer display="flex" flexDirection="column">
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="text_xxl" fontWeight="700">
              📚 Scolarité
            </Typography>
            <ButtonSquare onClick={handleAddClick} action="add" />
          </Box>
          <Divider sx={{ margin: "15px 0px" }} />
          <Box display="flex" flexDirection="column" gap="20px">
            {listeScolar.map((cerf) => (
              <Box key={cerf.id} display="flex" alignItems="center" justifyContent="space-between">
                <Box>
                  <Typography fontWeight="600" fontSize="14px" lineHeight="160%">
                    {cerf?.school_document_type?.name}
                  </Typography>
                  <Typography fontSize="12px" fontWeight="400" lineHeight="160%" color="#666D83">
                    {moment(cerf.obtained_date).format("MMMM YYYY")}
                  </Typography>
                </Box>
                <Box display="flex">
                  <ButtonSquare
                    onClick={() => {
                      handleModifyClick(cerf);
                      setIDScolar(cerf.id);
                    }}
                    action="modify"
                  />
                  <ButtonSquare onClick={() => window.open(cerf.files[0].file_url, "_blank")} action="download-blue" />
                  <ButtonSquare
                    onClick={() => {
                      setOpenDelete(true);
                      setIDScolar(cerf.id);
                    }}
                    action="delete"
                  />
                </Box>
              </Box>
            ))}
          </Box>
          {data?.links?.next && (
            <Box sx={{ cursor: "pointer" }} display="flex" justifyContent="center" alignItems="center">
              <ControlPointRoundedIcon fontSize="large" sx={{ color: `${colors.main}` }} onClick={handlePagination} />
            </Box>
          )}
        </BoxContainer>
      ) : (
        <Box display="flex" alignItems="center" justifyContent="center">
          <CircularProgress />
        </Box>
      )}

      <Modal open={open} onClose={() => setOpen(false)}>
        <Box sx={modalStyle}>
          <BoxContainer>
            <Box marginBottom="40px" display="flex" justifyContent="space-between" alignItems="center">
              <Typography variant="text_xxl" fontWeight="700">
                Scolarité
              </Typography>
              <ButtonSquare onClick={() => setOpen(false)} action="close" />
            </Box>
            <Formik
              innerRef={formikRef}
              initialValues={initialValues}
              onSubmit={(values) => {
                if (!idScolar) {
                  createScolar(values);
                } else {
                  ModifyScolar(values, idScolar);
                }
              }}
              validationSchema={idScolar ? validationSchemaUpdate : validationSchema}
            >
              {({ values, errors, setFieldValue, touched }) => (
                <Form>
                  <Box gap="20px" display="flex" flexDirection="column">
                    <Box>
                      <Box marginBottom="6px">
                        <Typography fontSize="14px" fontWeight="600" lineHeight="160%" display="inline">
                          Titre
                        </Typography>
                        <Typography fontSize="14px" fontWeight="600" lineHeight="160%" color={colors.main} display="inline">
                          *
                        </Typography>
                      </Box>
                      <Box>
                        <Autocomplete
                          ListboxProps={{ style: { maxHeight: "180px" } }}
                          disablePortal
                          fullWidth
                          id="combo-box-demo"
                          value={values?.titreObj}
                          onChange={(e, value) => {
                            if (value) {
                              setFieldValue("titre", value?.id);
                            }
                          }}
                          options={scolar}
                          getOptionLabel={(Option) => Option.name}
                          renderInput={(params) => (
                            <TextField
                              sx={{ maxWidth: "100%" }}
                              value={values.titre}
                              onChange={(e) => {
                                if (e.target.value) {
                                  if (e.target.value?.length > 0) {
                                    SearchScolar(e?.target?.value);
                                  } else {
                                    setScolar([]);
                                  }
                                }
                              }}
                              {...params}
                              variant="outlined"
                              InputProps={{
                                ...params.InputProps,
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <img src={RechercheIcon} alt="end" />
                                  </InputAdornment>
                                ),
                                endAdornment: null,
                              }}
                              placeholder="Scolarité..."
                            />
                          )}
                        />
                      </Box>
                    </Box>
                    <Box display="flex" gap="16px" sx={{ flexDirection: { xs: "column", sm: "row", md: "row", lg: "row" } }}>
                      <Box width="100%">
                        <Box marginBottom="6px">
                          <Typography fontSize="14px" fontWeight="600" lineHeight="160%" display="inline">
                            Date de délivrance
                          </Typography>
                          <Typography fontSize="14px" fontWeight="600" lineHeight="160%" color={colors.main} display="inline">
                            *
                          </Typography>
                        </Box>
                        <Field value={values.date} setFieldValue={setFieldValue} name="date" placeholder="Date..." /*maxDate={new Date()}*/ as={MyDP}></Field>
                        {errors.date && touched.date ? (
                          <Typography color="red" fontSize="12px">
                            {errors.date}
                          </Typography>
                        ) : null}
                      </Box>
                      <Box width="100%">
                        <Box marginBottom="6px">
                          <Typography fontSize="14px" fontWeight="600" lineHeight="160%" display="inline">
                            Pièce jointe
                          </Typography>
                        </Box>
                        <Box width="100%" position="relative">
                          <input
                            style={{ opacity: "0", width: "100%", height: "100%", position: "absolute", zIndex: "99999999999" }}
                            type="file"
                            name="file"
                            onChange={(e) => {
                              const doc = e.target.files[0];
                              setFieldValue("file", e.target.files[0]);
                              setFile(doc?.name);
                            }}
                          />
                          <MyTextField setFieldValue={setFieldValue} value={file} endAdornment="download" name="file" placeholder="Télécharger..." error={errors.password && touched.password ? true : false} />
                        </Box>
                        <Box marginTop="2px" alignItems="center" display="flex" gap="7px">
                          <Typography variant="text_clickable">Consulter le fichier</Typography>
                          <img src={checkLinkicon} alt="link-icon" />
                        </Box>
                      </Box>
                    </Box>
                    <Box display="flex" gap="10px" justifyContent="end" alignItems="center">
                      <Button onClick={() => setOpen(false)} variant="mj_secondary_md">
                        Annuler
                      </Button>
                      <Button type="submit" variant="mj_primary_md">
                        Enregistrer
                      </Button>
                    </Box>
                  </Box>
                </Form>
              )}
            </Formik>
          </BoxContainer>
        </Box>
      </Modal>
      <Modal
        open={openDelete}
        onClose={() => {
          setOpenDelete(false);
          setScolar([]);
        }}
      >
        <Box sx={modalStyle}>
          <BoxContainer>
            <Box marginBottom="40px" display="flex" justifyContent="space-between" alignItems="center">
              <Typography variant="text_xxl" fontWeight="700">
                Supprimer une scolaritée
              </Typography>
              <ButtonSquare onClick={() => setOpenDelete(false)} action="close" />
            </Box>
            <Box display="flex" flexDirection="column" gap="24px">
              <Box>
                <Typography sx={{ fontSize: "14px", fontWeight: "600", lineHeight: "160%" }}>Êtes-vous sûr de bien vouloir supprimer cette scolaritée</Typography>
              </Box>
              <Box display="flex" gap="10px" justifyContent="end" alignItems="center">
                <Button
                  onClick={() => {
                    setOpenDelete(false);
                    setScolar([]);
                  }}
                  variant="mj_secondary_md"
                >
                  Annuler
                </Button>
                <Button onClick={deleteScolar} variant="mj_danger_md">
                  Supprimer
                </Button>
              </Box>
            </Box>
          </BoxContainer>
        </Box>
      </Modal>
    </Box>
  );
}

export default Scolarite;
